import { formatKey } from "../../_helper";

const IdentificationImage = ({ image, keyVal }) => {
  return (
    <p>
      <strong className=" tw-text-primary">{formatKey(keyVal)}:</strong>{" "}
      <img
        src={image}
        alt="identification pic"
        className="tw-mt-2 tw-max-h-80 tw-w-[90%]"
      />
    </p>
  );
};

export default IdentificationImage;
